import React from 'react'
import { isNil } from 'lodash'

import { ButtonAndFormModal } from '@/components/layout/modals/ButtonAndFormModal'
import { KnowledgeBaseConnectionPanel } from '@/views/Organizations/components/KnowledgeBaseConnectionPanel'

/**
 * Opens the knowledge base connections panel for one org in a modal.
 *
 * @param {number} props.organizationId the org whose connections are managed
 * @param {string} [props.organizationName] shown in the modal title
 * @param {string} [props.buttonLabel]
 * @param {object} [props.buttonProps] passed to the trigger Button
 */
export const ManageKnowledgeBaseButton = ({
  organizationId,
  organizationName,
  buttonLabel = 'Manage Knowledge Base',
  buttonProps = { primary: true },
}) => {
  return (
    <ButtonAndFormModal
      buttonLabel={buttonLabel}
      modalTitle={
        isNil(organizationName)
          ? 'Knowledge base connections'
          : `Knowledge base connections · ${organizationName}`
      }
      modalId="manage-knowledge-base"
      modalProps={{ size: 'xlarge' }}
      buttonProps={buttonProps}
      form={<KnowledgeBaseConnectionPanel organizationId={organizationId} />}
    />
  )
}
